export default __webpack_public_path__ + "50f97eef0f5af2d5a3e578aa069af982.png";